export default __webpack_public_path__ + "static/media/add.1d39999e.svg";